module.exports = __webpack_public_path__ + "static/media/logo.a45c9b2c.svg";